import ApiService from '@/common/api.service'
import {
  PagesService,
} from "@/common/api.service";
import {
  FETCH_PAGE,
  FETCH_PAGES,
  PAGE_DELETE,
  PAGE_EDIT,
  PAGE_PUBLISH
} from "./actions.type";
import {
  SET_PAGE,
  SET_PAGES
} from "./mutations.type";
import { displayNotification } from "@/common/notification";

const initialState = {
  page: null,
  pages: []
};

export const state = { ...initialState };

export const actions = {
  async GET_PAGE_SCHEMA() {
    return ApiService.get('pages/schema')
  },

  async GET_TAG_SCHEMA() {
    return ApiService.get('pages/tag/schema')
  },

  async [FETCH_PAGE](context, pageId) {
    const { data } = await PagesService.get(pageId);
    context.commit(SET_PAGE, data.page);
    return data;
  },
  async [FETCH_PAGES](context) {
    const { data } = await PagesService.get();
    context.commit(SET_PAGES, data);
    return data;
  },
  [PAGE_DELETE](context, pageId) {
    return PagesService.destroy(pageId);
  },
  [PAGE_PUBLISH](context, page) {
    return PagesService.create(page);
  },
  [PAGE_EDIT](context, page) {
    // remove the _id property in the tag / backgroundContent / slides objects
    // this allows new and old tags to both be added / updated in the database
    let updatedPage = page;

    updatedPage.tags.forEach((tag, index) => {
      if (!isNaN(tag._id)) {
        let updated = Object.keys(tag).reduce((object, key) => {
          if (key !== '_id') {
            object[key] = tag[key];
          }
          return object;
        }, {})

        updatedPage.tags[index] = updated;
      }
    });

    updatedPage.interactiveSlides.forEach((slide, index) => {
      if (!isNaN(slide._id)) {
        let updated = Object.keys(slide).reduce((object, key) => {
          if (key !== '_id') {
            object[key] = slide[key];
          }
          return object;
        }, {})

        updatedPage.interactiveSlides[index] = updated;
      }
    });
    
    return PagesService.update(page._id, updatedPage)
      .then(res => {
        // update the state.page with response data from database
        // with new tag _id generated by database
        context.commit(SET_PAGE, res.data.page);
        displayNotification("Update successful", "success");
        return res.data.page
      })
      .catch(err => {
        displayNotification("Error updating page", "danger");
      });
  },
};

/* eslint no-param-reassign: ["error", { "props": false }] */
export const mutations = {
  [SET_PAGE](state, page) {
    state.page = page;
  },
  [SET_PAGES](state, pages) {
    state.pages = pages;
  },
};

const getters = {
  page(state) {
    return state.page;
  },
  pages(state) {
    return state.pages;
  },
};

export default {
  state,
  actions,
  mutations,
  getters
};
